/* Moves the CBB Frequently Bought Together widget inside .fbt-container on desktop. */
(function() {
  function checkAndAppend() {
    var fbtWidget = document.querySelector('.cbb-frequently-bought-container');
    var fbtContainer = document.querySelector('.fbt-container');
    if (fbtWidget && fbtContainer) {
      fbtContainer.appendChild(fbtWidget);
    }
  }

  function observeDOM() {
    var observer = new MutationObserver(function(mutationsList, obs) {
      for (var i = 0; i < mutationsList.length; i++) {
        var mutation = mutationsList[i];
        if (mutation.addedNodes) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.classList && node.classList.contains('cbb-frequently-bought-container')) {
              obs.disconnect();
              checkAndAppend();
              return;
            }
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (window.innerWidth > 768) {
    observeDOM();
  }
})();
